import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Train, TrainViewmodel,RefPointDateTime } from '../../models/train.model';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { User, UserList } from 'src/app/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class TrainService {

  gnBaseURL: any;
  TrainUser:string[]=[];
  constructor(private http: HttpClient,private appURL: AppConfigService) {
    this.gnBaseURL=this.appURL.getServerUrl(); 
  }

  getTrainById(id: string): Observable<Train> {
    return this.http.get<Train>(this.gnBaseURL + 'Trains/GetTrainById/' + id);
  }

  getAllTrains(): Observable<Train[]> {
    return this.http.get<Train[]>(this.gnBaseURL + 'Trains/GetTrainList');
  }

  getTrainByPlantId(id:string) {
    return this.http.get<Train[]>(this.gnBaseURL+ 'Trains/GetTrainByplantId/' + id);
  }

  GetAccessibleTrainListByPlantId(id:string){
    return this.http.get<Train[]>(this.gnBaseURL+ 'Trains/GetAccessibleTrainListByPlantId/' +id );
  }

  getTrainByPlantIdForGraph(id:string) {
    return this.http.get<Train[]>(this.gnBaseURL+ 'Trains/GetTrainByplantIdForGraph/' + id);
  }


  addTrain(
    addTrainRequest:TrainViewmodel
  ): Observable<Train> {
    console.log(addTrainRequest);
    return this.http.post<Train>(
      this.gnBaseURL + 'Trains/AddTrain',
      addTrainRequest
    );
  }

  updateTrain(addTrainRequest:TrainViewmodel): Observable<Train> {
    return this.http.post<Train>(
      this.gnBaseURL + 'Trains/EditTrain' ,
      addTrainRequest
    )

  }
  getUsersByTrainId(id: string): Observable<User[]> {
    return this.http.get<User[]>(this.gnBaseURL + 'Trains/GetTrainUsersByTrainId/' +id);
  }
  getAllowedUsersByTrainId(id: string): Observable<User[]> {
    return this.http.get<User[]>(this.gnBaseURL + 'Trains/GetTrainUsersByTrainIdForAllowedUsers/' +id);
  }
  GetUsersByPlantId(id: number): Observable<User[]> {
    return this.http.get<User[]>(this.gnBaseURL + 'Trains/GetUsersByPlantId/' +id);
  }

  deleteTrain(Id: number) {
    return this.http.get(
      this.gnBaseURL + 'Trains/'+ Id +'/action/delete' 
    );
  }

// Added below methods for calender control

 
getRefPointAndDateTimeByTrainId(trainId: number): Observable<RefPointDateTime> {
  return this.http.get<RefPointDateTime>(
     this.gnBaseURL + `Trains/GetRefPointAndDateTimeByTrainId/${trainId}`
  );
}
 
getRefPointIdsByDatetimeString(datetimeString: string, trainId: number): Observable<number[]> {
  return this.http.get<number[]>( this.gnBaseURL + `Trains/GetRefPointIdsByDatetimeString`, {
    params: {
      datetimeString: datetimeString,
      trainId: trainId.toString() // HttpClient converts to query string
    }
  });
}
 
 
getYearsByTrainId(trainId: number): Observable<number[]> {
  return this.http.get<number[]>(
    this.gnBaseURL + `Trains/GetYearsByTrainId/${trainId}`
  );
}
 
  getMonthsByTrainIdAndYear(trainId: number, year: number): Observable<number[]> {
    return this.http.get<number[]>( this.gnBaseURL + `Trains/GetMonthsByTrainIdAndYear/${trainId}/${year}`);
  }
 
  getDaysByTrainYearMonth(trainId: number, year: number, month: number): Observable<number[]> {
    return this.http.get<number[]>(this.gnBaseURL+`Trains/GetDaysByTrainYearMonth/${trainId}/${year}/${month}`);
  }
 
  getTimesByTrainYearMonthDay(trainId: number, year: number, month: number, day: number): Observable<string[]> {
    return this.http.get<string[]>(this.gnBaseURL+`Trains/GetTimesByTrainYearMonthDay/${trainId}/${year}/${month}/${day}`);
  }
 
 




}